import type { ReactNode } from "react";
import "./Banner.css";

type Tone = "ok" | "warn" | "err" | "info";

interface BannerProps {
  tone: Tone;
  children: ReactNode;
}

export function Banner({ tone, children }: BannerProps) {
  return <div className={`banner banner--${tone}`}>{children}</div>;
}
